/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetWorkbenchOverviewParams = zod.object({
	start: zod.string(),
	end: zod.string(),
	grain: zod.string().optional()
});

export type GetWorkbenchOverviewParams = zod.input<typeof GetWorkbenchOverviewParams>;
export type GetWorkbenchOverviewParamsOutput = zod.output<typeof GetWorkbenchOverviewParams>;
